import ShowContainer from './ShowContainer';

export default ShowContainer;
